export default __webpack_public_path__ + "static/platform-bg-06841d6876fa4de23cd68bdeab319d5f.png";